<template src="./template.html"></template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { clone } from 'lodash'

  export default {
    name: 'CartAddressFields',
    props: {
      addressDataKey: String,
      isInvoice: Boolean,
      countryOptionsKey: String,
      tabs: Array,
    },
    data() {
      return {
        timer: null,
        sub: null,
        optionalFields: '',
        activeGender: 0,
        activeCountry: '',
        activeAddressKey: '',
      }
    },
    computed: {
      ...mapState('formOptions', ['formOptions']),
      ...mapState('cart', [
        'isGuest',
        'cartRequiredFields',
      ]),
      ...mapState('deliveryAddress', [
        'deliveryAddress',
        'deliveryAddressActive',
      ]),
      ...mapState('invoiceAddress', ['invoiceAddress']),
      ...mapFields('deliveryAddress', {
        deliveryAddressAddress: 'deliveryAddress.address',
        deliveryAddressCountry: 'deliveryAddress.country',
        deliveryAddressCity: 'deliveryAddress.city',
        deliveryAddressAddressDetails: 'deliveryAddress.address_details',
        deliveryAddressEmail: 'deliveryAddress.email',
        deliveryAddressFirstname: 'deliveryAddress.firstname',
        deliveryAddressLastname: 'deliveryAddress.lastname',
        deliveryAddressGender: 'deliveryAddress.gender',
        deliveryAddressHouseNumber: 'deliveryAddress.house_number',
        deliveryAddressPhone: 'deliveryAddress.phone',
        deliveryAddressZip: 'deliveryAddress.zip',
      }),
      ...mapFields('invoiceAddress', {
        invoiceAddressAddress: 'invoiceAddress.address',
        invoiceAddressCountry: 'invoiceAddress.country',
        invoiceAddressCity: 'invoiceAddress.city',
        invoiceAddressAddressDetails: 'invoiceAddress.address_details',
        invoiceAddressEmail: 'invoiceAddress.email',
        invoiceAddressFirstname: 'invoiceAddress.firstname',
        invoiceAddressLastname: 'invoiceAddress.lastname',
        invoiceAddressGender: 'invoiceAddress.gender',
        invoiceAddressHouseNumber: 'invoiceAddress.house_number',
        invoiceAddressPhone: 'invoiceAddress.phone',
        invoiceAddressZip: 'invoiceAddress.zip',
      }),
      conf() {
        if (this.isInvoice) {
          return {
            type: 'bill',
            refID: '1',
          }
        } else {
          return {
            type: 'ship',
            refID: '2',
          }
        }
      },
      selectOptionsGender() {
        let selectOptions
        if (this.formOptions.gender_options) {
          selectOptions = JSON.parse(JSON.stringify(this.formOptions.gender_options))
          selectOptions.findIndex((ele, i) => {
            if (ele.type === '') {
              return selectOptions.splice(i, 1)
            }
          })
        }
        return selectOptions
      },
      selectOptionsCountry() {
        let selectOptions
        if (this.formOptions[this.countryOptionsKey]) {
          selectOptions = JSON.parse(JSON.stringify(this.formOptions[this.countryOptionsKey]))
          selectOptions.findIndex(({ code }, i) => {
            if (code === '') {
              return selectOptions.splice(i, 1)
            }
          })
        }
        return selectOptions
      },
      getGender() {
        let gender
        if (this.formOptions.gender_options) {
          gender = this.formOptions.gender_options.find(({ type }) => {
            return this[`${this.addressDataKey}Gender`] === 0 || this[`${this.addressDataKey}Gender`] === type
          })
        }
        return gender
      },
      getCountry() {
        let country
        if (this.formOptions[this.countryOptionsKey]) {
          country = this.formOptions[this.countryOptionsKey].find(ele => {
            return this[`${this.addressDataKey}Country`] === ele.code
          })
        }
        return country
      },
      isRequired() {
        return (
        [
          'bueffelbill',
          'marinmilou',
        ].includes(process.env.customer)
        )
      },
      selectedGender() {
        return this.activeGender || this[`${this.addressDataKey}Gender`]
      },
      selectedCountry() {
        return this.activeCountry || this[`${this.addressDataKey}Country`]
      },
      selectedAddressKey() {
        return this.activeAddressKey || `${this.addressDataKey}`
      },
    },
    created() {
      this.sub = this.$store.subscribe(mutation => {
        if (mutation.type.includes(this.addressDataKey) && mutation.type.includes('updateField')) {
          this.saveAddress()
        }
      })
    },
    beforeDestroy() {
      // unsubscribe subscription
      this.sub()
    },
    methods: {
      ...mapActions('deliveryAddress', {
        deliveryAddressUpdateAddress: 'updateAddress',
      }),
      ...mapActions('invoiceAddress', {
        invoiceAddressUpdateAddress: 'updateAddress',
      }),
      clone,
      saveAddress() {
        clearTimeout(this.timer)
        this.timer = setTimeout(_ => {
          this[`${this.addressDataKey}UpdateAddress`]({
            ...this[this.addressDataKey],
            separate_delivery_address: this.deliveryAddressActive,
          })
        }, 750)
      },
      custom() {
        return {
          on: [
            'search:blur',
            'input',
          ],
        }
      },
      isTabVisible(tab) {
        return this.tabs.indexOf(tab) + 1
      },
      onBlur(e) {
        this.optionalFields = e && e.target && e.target.value ? 'touched dirty valid validated changed passed' : ''
      },
      onChangeGender(e, addressKey) {
        this.activeGender = e
        this.activeAddressKey = addressKey
      },
      onChangeCountry(e, addressKey) {
        this.activeCountry = e
        this.activeAddressKey = addressKey
      },
    },
  }
</script>
